export default {
  description: 'Construct a vConnect object from a native object.',
  usage: ['v.expr(value) → value'],
  example: {
    description: 'Check if 2 values are equal',
    code: `v.expr({ value: 1 }).eq({ value: 1 })`
  }
}




// WEBPACK FOOTER //
// ./src/data/api/control_structures/expr.js